const O = "dacr_consent", fe = 1, me = "v1.", he = 15552e3, N = "cookie-notice-1", B = "dacr:cookie-consent", R = "dacr-consent", a = { analytics: !1, advertising: !1 }, C = { analytics: !0, advertising: !0 }, j = ["OPT_IN", "OPT_OUT"], $ = ["choice", "implied", "gpc"], K = (e) => typeof e == "string" && j.includes(e), H = (e) => typeof e == "string" && $.includes(e), v = (e) => typeof e == "boolean", G = (e) => btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""), X = (e) => {
  const t = e.replace(/-/g, "+").replace(/_/g, "/") + "===".slice((e.length + 3) % 4);
  return atob(t);
}, W = (e) => {
  if (typeof e != "object" || e === null) return !1;
  const t = e;
  return t.schema === 1 && typeof t.consentId == "string" && typeof t.decisionId == "string" && K(t.consentType) && H(t.method) && typeof t.categories == "object" && t.categories !== null && v(t.categories.analytics) && v(t.categories.advertising) && typeof t.ts == "number" && typeof t.ver == "string" && typeof t.build == "string" && v(t.logged);
}, J = (e) => "v1." + G(JSON.stringify(e)), T = (e) => {
  if (!e || e.indexOf("v1.") !== 0) return null;
  try {
    const t = X(e.slice(3)), o = JSON.parse(t);
    return W(o) ? o : null;
  } catch {
    return null;
  }
}, q = (e, { consentType: t, gpc: o, noticeVersion: s, now: n }) => !(!e || e.ts + 15552e3 * 1e3 <= n || e.ver !== s || e.consentType !== t || t === "OPT_IN" && e.method === "implied" || o && (e.categories.analytics || e.categories.advertising)), k = ({
  cookie: e,
  consentType: t,
  gpc: o,
  noticeVersion: s,
  now: n
}) => {
  const d = q(e, { consentType: t, gpc: o, noticeVersion: s, now: n }), i = e?.consentId ?? null;
  return o ? {
    consentType: t,
    granted: { ...a },
    gpc: !0,
    showBanner: !1,
    pending: !(d && e?.method === "gpc"),
    method: d ? e.method : "gpc",
    consentId: i,
    noticeVersion: s
  } : d && e ? {
    consentType: t,
    granted: { ...e.categories },
    gpc: !1,
    showBanner: !1,
    pending: !1,
    method: e.method,
    consentId: i,
    noticeVersion: s
  } : t === "OPT_IN" ? {
    consentType: t,
    granted: { ...a },
    gpc: !1,
    showBanner: !0,
    pending: !0,
    method: null,
    consentId: i,
    noticeVersion: s
  } : {
    consentType: t,
    granted: { ...C },
    gpc: !1,
    showBanner: !1,
    pending: !0,
    method: null,
    consentId: i,
    noticeVersion: s
  };
}, Y = (e) => e === "localhost" || e === "127.0.0.1" || e === "::1" || e.endsWith(".localhost"), P = (e) => Y(e) ? null : e === "dev.dacr.com" || e.endsWith(".dev.dacr.com") ? ".dev.dacr.com" : e === "dacr.com" || e.endsWith(".dacr.com") ? ".dacr.com" : null, U = (e) => {
  const t = ["Path=/", `Max-Age=${e}`, "SameSite=Lax"], o = P(location.hostname);
  return o && t.push(`Domain=${o}`), location.protocol === "https:" && t.push("Secure"), t.join("; ");
}, z = (e) => {
  const t = `${e}=`, o = document.cookie ? document.cookie.split("; ") : [];
  for (const s of o)
    if (s.indexOf(t) === 0) return s.slice(t.length);
  return null;
}, u = () => T(z(O)), Q = (e) => {
  document.cookie = `${O}=${J(e)}; ${U(
    15552e3
  )}`;
}, Z = () => {
  document.cookie = `${O}=; ${U(0)}`;
}, S = [
  {
    id: "dacr-consent",
    name: "dacr_consent",
    match: "exact",
    provider: "Dacr",
    privacyUrl: "/legal/privacy",
    domains: ["dacr.com"],
    category: "necessary",
    purpose: "Cookie consent",
    trigger: "Set when you make or imply a cookie choice.",
    duration: "180 days",
    party: "first",
    sourceFiles: ["packages/consent/src/cookie.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "aegis-refresh",
    name: "__aegis_refresh",
    match: "exact",
    provider: "Dacr",
    privacyUrl: "/legal/privacy",
    domains: ["dacr.com"],
    category: "necessary",
    purpose: "User authentication",
    trigger: "Set on sign-in.",
    duration: "90 days",
    party: "first",
    sourceFiles: ["packages/auth/src"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "stripe-mid",
    name: "__stripe_mid",
    match: "exact",
    provider: "Stripe",
    privacyUrl: "https://stripe.com/privacy",
    domains: ["js.stripe.com", "m.stripe.com"],
    category: "necessary",
    purpose: "Payment processing",
    trigger: "Set only when the checkout flow is invoked.",
    duration: "1 year",
    party: "third",
    sourceFiles: ["apps/web/src/shared/services/stripe.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "stripe-sid",
    name: "__stripe_sid",
    match: "exact",
    provider: "Stripe",
    privacyUrl: "https://stripe.com/privacy",
    domains: ["js.stripe.com", "m.stripe.com"],
    category: "necessary",
    purpose: "Payment processing",
    trigger: "Set only when the checkout flow is invoked.",
    duration: "30 minutes",
    party: "third",
    sourceFiles: ["apps/web/src/shared/services/stripe.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "ga",
    name: "_ga",
    match: "prefix",
    provider: "Google",
    privacyUrl: "https://business.safety.google/adscookies/",
    domains: ["www.google-analytics.com", "www.googletagmanager.com"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Set after analytics consent.",
    duration: "2 years",
    party: "third",
    sourceFiles: ["apps/website/src/layouts/Base.astro", "apps/web/index.html"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "ga-gid",
    name: "_gid",
    match: "exact",
    provider: "Google",
    privacyUrl: "https://business.safety.google/adscookies/",
    domains: ["www.google-analytics.com", "www.googletagmanager.com"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Set after analytics consent.",
    duration: "24 hours",
    party: "third",
    sourceFiles: ["apps/website/src/layouts/Base.astro", "apps/web/index.html"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "ga-gat",
    name: "_gat",
    match: "prefix",
    provider: "Google",
    privacyUrl: "https://business.safety.google/adscookies/",
    domains: ["www.google-analytics.com", "www.googletagmanager.com"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Set after analytics consent.",
    duration: "1 minute",
    party: "third",
    sourceFiles: ["apps/website/src/layouts/Base.astro", "apps/web/index.html"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "posthog",
    name: "^ph_.*_posthog$",
    match: "regex",
    provider: "PostHog",
    privacyUrl: "https://posthog.com/privacy",
    domains: ["hog.dacr.com"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Sets a cookie only after analytics consent.",
    duration: "1 year",
    party: "first",
    sourceFiles: ["apps/web/src/shared/services/analytics.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "logrocket-tabs",
    name: "_lr_tabs_",
    match: "prefix",
    provider: "LogRocket",
    privacyUrl: "https://logrocket.com/privacy",
    domains: ["*.logrocket.io", "*.lr-ingest.io"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Set after analytics consent.",
    duration: "1 day",
    party: "third",
    sourceFiles: ["apps/web/src/shared/services/analytics.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "logrocket-hb",
    name: "_lr_hb_",
    match: "prefix",
    provider: "LogRocket",
    privacyUrl: "https://logrocket.com/privacy",
    domains: ["*.logrocket.io", "*.lr-ingest.io"],
    category: "analytics",
    purpose: "Product analytics",
    trigger: "Set after analytics consent.",
    duration: "Session",
    party: "third",
    sourceFiles: ["apps/web/src/shared/services/analytics.ts"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "meta-fbp",
    name: "_fbp",
    match: "exact",
    provider: "Meta",
    privacyUrl: "https://www.facebook.com/privacy/policies/cookies/",
    domains: ["connect.facebook.net", "www.facebook.com"],
    category: "advertising",
    purpose: "Marketing measurement",
    trigger: "Set after advertising consent.",
    duration: "90 days",
    party: "third",
    sourceFiles: ["apps/website/src/layouts/Base.astro", "apps/web/index.html"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "meta-fbc",
    name: "_fbc",
    match: "exact",
    provider: "Meta",
    privacyUrl: "https://www.facebook.com/privacy/policies/cookies/",
    domains: ["connect.facebook.net", "www.facebook.com"],
    category: "advertising",
    purpose: "Marketing measurement",
    trigger: "Set after advertising consent.",
    duration: "90 days",
    party: "third",
    sourceFiles: ["apps/website/src/layouts/Base.astro", "apps/web/index.html"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "hop-id",
    name: "__hop-id",
    match: "exact",
    provider: "Dacr",
    privacyUrl: "/legal/privacy",
    domains: ["dacr.com"],
    category: "advertising",
    purpose: "Marketing measurement",
    trigger: "Set at the edge when a tracked link is followed.",
    duration: "210 days",
    party: "first",
    sourceFiles: ["apps/website/resources/redirectFunction.yml"],
    lastVerifiedAt: "2026-07-21"
  },
  {
    id: "aff-id",
    name: "__aff-id",
    match: "exact",
    provider: "Dacr",
    privacyUrl: "/legal/privacy",
    domains: ["dacr.com"],
    category: "advertising",
    purpose: "Marketing measurement",
    trigger: "Set at the edge when an affiliate link is followed.",
    duration: "14 days",
    party: "first",
    sourceFiles: ["backend/redirects/resources/redirectFunction.yml"],
    lastVerifiedAt: "2026-07-21"
  }
], I = (e) => S.filter((t) => t.category === e).flatMap((t) => t.domains), ee = "hog.dacr.com", ve = () => Array.from(
  /* @__PURE__ */ new Set([...I("analytics"), ...I("advertising")])
).filter((e) => e !== ee), we = (e) => S.filter((t) => t.category === e), te = ["analytics", "advertising"], oe = (e, t, o) => {
  if (t === "exact") return o === e;
  if (t === "prefix") return o.indexOf(e) === 0;
  try {
    return new RegExp(e).test(o);
  } catch {
    return !1;
  }
}, se = () => (document.cookie ? document.cookie.split("; ") : []).map((e) => e.slice(0, e.indexOf("="))).filter(Boolean), A = (e) => {
  const t = /* @__PURE__ */ new Set([
    null,
    P(location.hostname)
  ]);
  for (const o of t) {
    let s = `${e}=; Path=/; Max-Age=0; SameSite=Lax`;
    o && (s += `; Domain=${o}`), location.protocol === "https:" && (s += "; Secure"), document.cookie = s;
  }
}, re = (e) => {
  const t = S.filter((o) => e.includes(o.category));
  for (const o of t)
    if (o.match === "exact")
      A(o.name);
    else
      for (const s of se())
        oe(o.name, o.match, s) && A(s);
}, D = () => re(te), g = "dacr_consent_outbox", ne = "0000000";
let y, c = N, x = !1, w = !1, r = null;
const _ = /* @__PURE__ */ new Set();
let b = null;
const f = () => Date.now(), L = () => crypto.randomUUID(), F = () => navigator.globalPrivacyControl === !0, ae = () => location.origin + location.pathname, ie = (e) => e === "gpc" ? "GPC" : "CHOICE", V = () => {
  try {
    const e = localStorage.getItem(g), t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t : [];
  } catch {
    return [];
  }
}, E = (e) => {
  try {
    e.length ? localStorage.setItem(g, JSON.stringify(e)) : localStorage.removeItem(g);
  } catch {
  }
}, ce = async (e) => {
  try {
    const t = await fetch(y.apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", "dacr-platform": "web" },
      credentials: "omit",
      body: JSON.stringify({
        query: "mutation($input: RecordCookieConsentDecisionInput!) { recordCookieConsentDecision(input: $input) { decisionId recordedAt } }",
        variables: { input: e }
      })
    });
    return t.ok ? !(await t.json()).errors : !1;
  } catch {
    return !1;
  }
}, M = async () => {
  const e = V();
  if (!e.length) return;
  const t = [];
  for (const o of e)
    await ce(o.input) || t.push(o);
  E(t);
}, de = (e) => {
  E([...V(), { input: e }]), M();
}, m = (e) => {
  r = e, _.forEach((t) => t(e)), typeof document < "u" && document.dispatchEvent(new CustomEvent(B, { detail: e }));
}, le = (e, t, o, s, n) => ({
  schema: 1,
  consentId: s,
  decisionId: L(),
  consentType: e,
  method: t,
  categories: o,
  ts: f(),
  ver: c,
  build: y.buildSha,
  logged: n
}), pe = (e) => ({
  consentId: e.consentId,
  decisionId: e.decisionId,
  occurredAt: e.ts,
  displayedConsentType: e.consentType,
  method: ie(e.method),
  categories: e.categories,
  noticeVersion: e.ver,
  buildSha: e.build,
  url: ae()
}), p = (e, t, o, s = r?.gpc ?? !1) => {
  const n = r?.granted ?? a, d = r?.consentId ?? u()?.consentId ?? L(), i = n.analytics && !o.analytics || n.advertising && !o.advertising, h = le(
    e,
    t,
    o,
    d,
    t !== "implied"
  );
  if (Q(h), t !== "implied" && de(pe(h)), b?.postMessage("changed"), i) {
    D(), location.reload();
    return;
  }
  m(k({ cookie: h, consentType: e, gpc: s, noticeVersion: c, now: f() }));
}, _e = () => {
  const e = r?.consentType ?? "OPT_IN";
  r?.gpc || p(e, "choice", { ...C });
}, ge = () => {
  const e = r?.consentType ?? "OPT_IN";
  p(e, "choice", { ...a });
}, be = (e) => {
  const t = r?.consentType ?? "OPT_IN";
  if (r?.gpc) return;
  const o = r?.granted ?? a;
  !r?.pending && o.analytics === e.analytics && o.advertising === e.advertising || p(t, "choice", { ...e });
}, Oe = () => ge(), ue = async () => {
  try {
    return (await (await fetch(y.apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", "dacr-platform": "web" },
      credentials: "omit",
      cache: "no-store",
      body: JSON.stringify({
        query: "query { cookieConsentContext { consentType gpcObserved } }"
      })
    })).json())?.data?.cookieConsentContext ?? null;
  } catch {
    return null;
  }
}, ye = (e) => {
  if (w) return;
  w = !0;
  const t = e?.consentType ?? "OPT_IN", o = (e?.gpcObserved ?? !1) || F(), s = u(), n = k({ cookie: s, consentType: t, gpc: o, noticeVersion: c, now: f() });
  if (o && n.pending) {
    p(t, "gpc", { ...a }, !0);
    return;
  }
  if (!o && n.pending && t !== "OPT_IN") {
    p(t, "implied", { ...C }, !1);
    return;
  }
  m(n), M();
}, Ce = () => r, ke = (e) => (_.add(e), r && e(r), () => _.delete(e)), l = () => {
  if (!w) return;
  const e = u();
  m(
    k({
      cookie: e,
      consentType: r?.consentType ?? "OPT_IN",
      gpc: r?.gpc ?? !1,
      noticeVersion: c,
      now: f()
    })
  );
}, Se = (e) => {
  if (!x) {
    x = !0, y = { ...e, buildSha: e.buildSha || ne }, c = e.noticeVersion ?? N, m({
      consentType: "OPT_IN",
      granted: { ...a },
      gpc: F(),
      showBanner: !1,
      pending: !0,
      method: null,
      consentId: u()?.consentId ?? null,
      noticeVersion: c
    }), ue().then(ye);
    try {
      b = new BroadcastChannel(R), b.addEventListener("message", l);
    } catch {
    }
    window.addEventListener("storage", (t) => {
      (t.key === g || t.key === null) && l();
    }), window.addEventListener("focus", l), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible" && l();
    }), window.addEventListener("pageshow", l);
  }
}, Ee = () => {
  Z(), E([]), D();
}, Ie = (e, t) => {
  if (t) return !1;
  const o = T(e);
  return !!o && o.method === "choice" && o.categories.advertising === !0;
};
export {
  ee as ALLOWED_HOST_WHEN_DENIED,
  R as BROADCAST_CHANNEL,
  S as CATALOG,
  B as CONSENT_EVENT,
  he as COOKIE_MAX_AGE,
  O as COOKIE_NAME,
  fe as COOKIE_SCHEMA,
  me as COOKIE_VALUE_PREFIX,
  N as CURRENT_NOTICE_VERSION,
  a as DENIED,
  C as GRANTED,
  _e as accept,
  Ie as advertisingAttributionAllowed,
  ve as blockedHostsWhenDenied,
  we as catalogByCategory,
  re as cleanupCategories,
  D as cleanupOptional,
  ge as decline,
  T as decodeCookie,
  Z as deleteConsentCookie,
  J as encodeCookie,
  k as evaluate,
  Ce as getState,
  Se as initConsent,
  q as isValidCookie,
  u as readConsentCookie,
  Ee as resetConsent,
  P as resolveCookieDomain,
  be as save,
  ke as subscribe,
  Oe as withdraw,
  Q as writeConsentCookie
};
